import type { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/profile",
    name: "candidate-profile",
    props: true,
    component: () => import("@/views/Candidate/CandidateProfile.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "My Profile",
    },
  },
  {
    path: "/logo",
    name: "candidate-logo",
    props: true,
    component: () => import("../views/Candidate/CandidateLogo.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "My Logo",
    },
  },
  {
    path: "/admins",
    name: "candidate-admins",
    props: true,
    component: () => import("../views/Candidate/CandidateAdmins.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "Admins",
    },
  },
  // {
  //   path: "/candidate-dashboard/employees",
  //   name: "candidate-employees",
  //   props: true,
  //   component: () => import("../views/candidate-dashboard/CandidateEmployees.vue"),
  //     );
  //   },
  //   meta: {
  //     requiresAuth: true,
  //     authorizedRoles: [ "Admin", "Candidate" ],
  //     friendlyName: "My Employees",
  //   },
  // },
  {
    path: "/sponsorships",
    name: "sponsorships",
    props: true,
    component: () => import("@/views/common/Sponsorships/Sponsorships.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "Sponsorships",
    },
  },
  {
    path: "/voter-rewards",
    name: "voter-rewards",
    props: true,
    component: () =>
      import("@/views/common/Sponsorships/Dashboard/VoterRewards.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "Voter Rewards",
    },
  },
  {
    path: "/awards-ceremony",
    name: "awards-ceremony",
    props: true,
    component: () => import("@/views/Candidate/CandidateAwardsCeremony.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "Awards Ceremony",
    },
  },
  {
    path: "/plaques",
    name: "plaques",
    props: true,
    component: () => import("@/views/Candidate/Plaques.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "Plaques",
    },
  },
  {
    path: "/winners-guide",
    name: "winners-guide",
    props: true,
    component: () => import("@/views/Candidate/Magazine.vue"),
    meta: {
      requiresAuth: true,
      authorizedRoles: ["Candidate"],
      friendlyName: "Winners Guide",
    },
  },
] as RouteRecordRaw[];
